<template>
  <div class="wrapp" id="sfatwrapp">
    <div class="row">
      <div class="col-12">
        <h4>Veículos Programados com SFAT</h4>
        <!--
        <b-alert show variant="info" class="explain">
        </b-alert>
        -->
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="row col-12">
        <div class="col-3 form-inline mb-2">
            <b-form-input
              id="sfatsearch"
              v-model="filter"
              @keyup="search"
              placeholder="Buscar ..."
            >
            </b-form-input>
            <button
              class="btn btn-primary"
              style="margin-left: 2px;"
              @click="resetSearch"
            >
              Limpar
            </button>
        </div>
        <div class="col-5 form-inline wid100">
            <div class="form-inline wid100">
              <form class="col-12 text-right form-inline">
                  <div class="col-6">
                    <label for="aop">Área Operacional</label>
                    <b-form-select
                        id="aop"
                        :options="aopOptions"
                        v-model="selectedAop"
                        value="Todas"
                        class="col-12"
                        @change="changeAopFilter"
                    >
                    </b-form-select>
                    </div>
                    <div class="col-6">
                    <label for="concessionario">Concessionário</label>
                    <b-form-select
                        id="concessionario"
                        :options="dealersOptions"
                        v-model="selectedDealer"
                        value="Todas"
                        class="col-12"
                        @change="changeDealersFilter"
                    >
                    </b-form-select>
                  </div>
              </form>
            </div>
        </div>
        <div class="col-4" v-if="showTab == 0">
            <form @submit="false" class="f-right text-right pt20">
              <div class="text-right f-right">
                <input
                  @click="changePublished"
                  type="checkbox"
                  class="custom-control-input"
                  id="select-published"
                  name="select-published"
                />
                <label
                  class="custom-control-label check-rounded"
                  for="select-published"
                >Filtrar somente disponibilizados</label>
              </div>
            </form>
        </div>
        <!--
        <div class="col-2">
            <form @submit="false" class="f-right text-right pt20">
              <div class="text-right f-right">
                <input
                  @click="changeInterested"
                  type="checkbox"
                  class="custom-control-input"
                  id="select-interested"
                  name="select-interested"
                />
                <label
                  class="custom-control-label check-rounded"
                  for="select-interested"
                >Somente com interesse</label>
              </div>
            </form>
        </div>
        -->
      </div>
    </div>
    <div class="row col-12">
      <b-tabs content-class="" v-model="showTab">
        <b-tab title="Meus Veículos Programados" active>
          <div
            v-if="loading"
            class="text-center"
          >
            <b-spinner
              variant="primary"
              type="grow"
              label="Spinning"
            ></b-spinner>
          </div>
          <div v-else>
            <div style="">
              <h5> Total de veículos Programados: {{ total }} </h5>
              <div class="row virtualstock">
                <div class="col-12 mt-3">
                  <b-table
                    :items="items"
                    :fields="fields"
                    style=""
                    id="myStockTable"
                  >
                    <template v-slot:cell(data_estoque)="row">
                        {{ convertDate(row.item.data_estoque) }}
                    </template>
                    <template v-slot:cell(data_inclusao)="row">
                        {{ convertDate(row.item.data_inclusao) }}
                    </template>
                    <template v-slot:cell(acao)="row">
                      <div class="text-center">
                        <div v-if="row.item.status_oferta == 1"
                          class="fa fa-minus"
                          title="Veículo Ofertado"
                          @click="publishStock(row.item, false)"
                        >
                        </div>
                        <div v-else-if="row.item.status_oferta == 2"
                          class="fa fa-check nopointer"
                          title="Veículo Transferido"
                        >
                        </div>
                        <div v-else-if="row.item.status_oferta == 3"
                          class="fa fa-times nopointer"
                          title="Expirada"
                        >
                        </div>
                        <div v-else
                          class="fa fa-plus"
                          title="Ofertar Veículo"
                          @click="$bvModal.show(`input-data${row.item.id_estoque_virtual}`)"
                        >
                        </div>
                        <b-modal
                          size="lg"
                          :id="`input-data${row.item.id_estoque_virtual}`"
                          title="Informações para contato"
                          @ok="publishStock(row.item, true)">
                          <b-alert show variant="danger">
                            Declaro que tenho autorização da Diretoria do Concessionário
                            para cadastrar esta transferência irreversível
                          </b-alert>
                          <b-alert show variant="info">
                            Informe os dados do responsável para
                            que outro concessionário entre em contato caso necessário.
                          </b-alert>
                          <div class="row">
                            <div class="col-6">
                              <label for="input-name">Nome</label>
                              <input
                                id="input-name"
                                v-model="nome"
                                type="text"
                                required
                                class="form-control"
                              >
                            </div>
                            <div class="col-6">
                              <label for="input-phone">Telefone</label>
                              <input
                                id="input-phone"
                                v-model="telefone"
                                type="text"
                                required
                                class="form-control"
                              >
                            </div>
                            <div class="col-12">
                              <label for="input-email">Email</label>
                              <input
                                id="input-email"
                                v-model="email"
                                type="text"
                                required
                                class="form-control"
                              >
                            </div>
                          </div>
                        </b-modal>
                      </div>
                    </template>
                    <!--
                    <template v-slot:cell(status)="row">
                    {{ crow.item.status }}
                    </template>
                    -->
                  </b-table>
                </div>
                <div class="pagination-users">
                    <paginate
                      v-model="page"
                      :page-count="Math.ceil(this.total / this.limit)"
                      :click-handler="changePage"
                      :prevText="'‹'"
                      :nextText="'›'"
                      :activeClass="'active'"
                      :containerClass="'pagination b-pagination'"
                      :pageClass="'page-item'"
                    >
                    </paginate>
                  </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Veículos Programados Disponibilizados">
          <div
            v-if="loading"
            class="text-center"
          >
            <b-spinner
              variant="primary"
              type="grow"
              label="Spinning"
            ></b-spinner>
          </div>
          <div v-else>
            <div style="">
              <h5> Total de veículos Disponibilizados: {{ totalOfertas }} </h5>
              <div class="row virtualstock">
                <div class="col-12 mt-3">
                  <b-table
                    :items="itemsOfertasTabela"
                    :fields="fieldsOfertas"
                    id="myOfferTable"
                    style=""
                    per-page="10"
                    :current-page="pageOfertas"
                  >
                    <template v-slot:cell(data_estoque)="row">
                        {{ convertDate(row.item.data_estoque) }}
                    </template>
                    <template v-slot:cell(data_inclusao)="row">
                        {{ convertDate(row.item.data_inclusao) }}
                    </template>
                    <template v-slot:cell(data_oferta)="row">
                        {{ convertDate(row.item.data_oferta) }}
                    </template>
                    <template v-slot:cell(modelo)="row">
                        {{ row.item.modelo }}
                    </template>
                    <template v-slot:cell(up)="row">
                        {{ row.item.up }}
                    </template>
                    <template v-slot:cell(cor)="row">
                        {{ row.item.cor }}
                    </template>
                    <template v-slot:cell(codigo_cor)="row">
                        {{ row.item.codigo_cor }}
                    </template>
                    <template v-slot:cell(anomodelo)="row">
                        {{ row.item.anomodelo }}
                    </template>
                    <template v-slot:cell(anofabricacao)="row">
                        {{ row.item.anofabricacao }}
                    </template>
                    <template v-slot:cell(previsao)="row">
                        {{ row.item.previsao }}
                    </template>
                    <template v-slot:cell(dealer)="row">
                        {{ row.item.dealer }}
                    </template>
                    <template v-slot:cell(baumuster)="row">
                        {{ row.item.baumuster }}
                    </template>
                    <template v-slot:cell(variante)="row">
                        {{ row.item.variante }}
                    </template>
                    <template v-slot:cell(acao)="row">
                      <div class="text-center">
                        <div v-if="row.item.status_oferta == 0"
                          class="fa fa-minus nopointer"
                          title="Inativa"
                        >
                        </div>
                        <div v-else-if="row.item.status_oferta == 2"
                          class="fa fa-check nopointer"
                          title="Finalizada"
                        >
                        </div>
                        <div v-else-if="row.item.status_oferta == 3"
                          class="fa fa-times nopointer"
                          title="Expirada"
                        >
                        </div>
                        <div v-else
                          class="fa fa-plus"
                          title="Transferir Veículo"
                          @click="openModalAccept(row.item)"
                        >
                        </div>
                        <b-modal
                          size="lg"
                          :id="`accept${row.item.id_estoque_virtual}`"
                          title="Informações para transferência do veículo"
                          @ok="acceptStock(row.item)">
                          <b-alert show variant="danger">
                            Declaro que tenho autorização da Diretoria do Concessionário
                            para cadastrar esta transferência irreversível
                          </b-alert>
                          <b-alert show variant="info">
                            Informe os dados de contato do responsável e a concessionária
                            para qual deseja transferir o veículo
                          </b-alert>
                          <div class="row">
                            <div class="col-6">
                              <label for="accept-name">Nome</label>
                              <input
                                id="accept-name"
                                v-model="nome"
                                type="text"
                                required
                                class="form-control"
                              >
                            </div>
                            <div class="col-6">
                              <label for="accept-phone">Telefone</label>
                              <input
                                id="accept-phone"
                                v-model="telefone"
                                type="text"
                                required
                                class="form-control"
                              >
                            </div>
                            <div class="col-6">
                              <label for="accept-email">Email</label>
                              <input
                                id="accept-email"
                                v-model="email"
                                type="text"
                                required
                                class="form-control"
                              >
                            </div>
                            <div class="col-6" style="display: grid !important;">
                              <label for="accept-dealer">Concessionário</label>
                              <b-select
                                  id="accept-dealer"
                                  :options="acceptDealersOptions"
                                  v-model="selectedAcceptDealer"
                                  class="form-control"
                              >
                              </b-select>
                            </div>
                          </div>
                        </b-modal>
                      </div>
                    </template>
                  </b-table>
                </div>
                <b-pagination
                  v-model="pageOfertas"
                  :total-rows="totalOfertas"
                  per-page="10"
                  aria-controls="myOfferTable"
                ></b-pagination>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import axios from 'axios';
// import stockFilters from '../../../organisms/stock-filter/index.vue';
import EventBus from '../../../../eventBus';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  name: 'VirtualStock',
  components: {
    // stockFilters,
  },
  data: () => ({
    filter: null,
    userType: null,
    nome: null,
    email: null,
    telefone: null,
    typingTimer: null,
    doneTypingInterval: 500,
    userAuth: null,
    items: [],
    itemsOfertas: [],
    itemsOfertasTabela: [],
    selectedAop: 'Todas',
    selectedDealer: 'Todas',
    interested: false,
    published: false,
    areasOperacionais: [],
    page: 1,
    pageOfertas: 1,
    limit: 10,
    total: 0,
    totalOfertas: 0,
    ctcli: [],
    aopOptions: [],
    dealersOptions: [],
    acceptDealersOptions: [],
    selectedAcceptDealer: null,
    showTab: 0,
    loading: true,
    fields: [
      { key: 'acao', label: 'Ação' },
      { key: 'data_estoque', label: 'Data Estoque' },
      { key: 'modelo', label: 'Modelo' },
      { key: 'up', label: 'Up' },
      { key: 'cor', label: 'Cor' },
      { key: 'codigo_cor', label: 'Codigo Cor' },
      { key: 'anomodelo', label: 'Ano Modelo' },
      { key: 'anofabricacao', label: 'Ano Fabricação' },
      { key: 'previsao', label: 'Previsão' },
      { key: 'dealer', label: 'Concessionário' },
      { key: 'data_inclusao', label: 'Data Inclusão' },
      { key: 'baumuster', label: 'Baumuster' },
      { key: 'variante', label: 'Variante' },
      { key: 'vin', label: 'Vin' },
      { key: 'pedido_alemao', label: 'Pedido Alemão' },
      { key: 'numero_sfat', label: 'Número SFAT' },
    ],
    fieldsOfertas: [
      { key: 'acao', label: 'Ação' },
      { key: 'data_estoque', label: 'Data Estoque' },
      { key: 'modelo', label: 'Modelo' },
      { key: 'up', label: 'Up' },
      { key: 'cor', label: 'Cor' },
      { key: 'codigo_cor', label: 'Codigo Cor' },
      { key: 'anomodelo', label: 'Ano Modelo' },
      { key: 'anofabricacao', label: 'Ano Fabricação' },
      { key: 'previsao', label: 'Previsão' },
      { key: 'dealer', label: 'Concessionário' },
      { key: 'data_inclusao', label: 'Data Inclusão' },
      { key: 'data_oferta', label: 'Data Oferta' },
      { key: 'nome', label: 'Nome' },
      { key: 'email', label: 'Email' },
      { key: 'telefone', label: 'Telefone' },
      { key: 'baumuster', label: 'Baumuster' },
      { key: 'variante', label: 'Variante' },
      { key: 'vin', label: 'Vin' },
      { key: 'pedido_alemao', label: 'Pedido Alemão' },
      { key: 'numero_sfat', label: 'Número SFAT' },
    ],
  }),
  watch: {
    showTab: function watchShowTab() {
      if (this.showTab === 0) {
        this.selectedAop = 'Todas';
        this.selectedDealer = 'Todas';
        this.filter = null;
        this.getOffers();
        this.loadData();
      } else {
        this.selectedAop = 'Todas';
        this.selectedDealer = 'Todas';
        this.filter = null;
        this.getOffers();
      }
    },
  },
  computed: {
    ...mapState('users', ['user']),
    ...mapFields('dealers', ['dealers']),
  },
  methods: {
    ...mapActions('users', ['getUser']),
    ...mapActions('dealers', ['getDealers']),
    
    async loadData() {
      if (this.ctcli.length > 0) {
        try {
          this.loading = true;
          const { data } = await axios.get(`${url}/estoques-virtuais`, {
            params: {
              page: this.page,
              limit: this.limit,
              filter: this.filter ? this.filter : null,
              ctcli: this.ctcli,
              published: this.published,
              interested: this.interested,
              segmentos: this.userAuth.segmentos,
            }
          });
          for (let i = 0; i < data.estoque.length; i += 1) {
            for (let j = 0; j < this.itemsOfertas.length; j += 1) {
              if (this.itemsOfertas[j].id_estoque_virtual === data.estoque[i].id_estoque_virtual) {
                data.estoque[i].status_oferta = this.itemsOfertas[j].status_oferta;
                break;
              }
            }
            for (let j = 0; j < this.dealers.length; j += 1) {
              if (this.dealers[j].account === data.estoque[i].ctcli) {
                data.estoque[i].dealer = this.dealers[j].name;
                break; 
              }
            }
          }
          this.items = data.estoque;
          this.total = data.total;
        } catch (error) {
          window.console.log('Falhou!', error);
        }
        this.loading = false;
      }
    },
    async buildCtcli() {
      this.ctcli = [];
      if (this.selectedAop === 'Todas') {
        if (this.selectedDealer === 'Todas') {
          if (this.showTab === 0) {
            for (const obj of this.user.dealers) {
              this.ctcli.push(obj.account);
            }
          }
        } else {
          this.ctcli.push(this.selectedDealer);
        }
      } else {
        if (this.selectedDealer === 'Todas') {
          for (let i = 0; i < this.user.dealers.length; i += 1) {
            if (this.user.dealers[i].operational_area.toString() === this.selectedAop) {
              this.ctcli.push(this.user.dealers[i].account);
            }
          }
        } else {
          this.ctcli.push(this.selectedDealer);
        }
      }
    },
    async getOffers() {
      this.loading = true;
      try {
        await this.buildCtcli();
        const { data } = await axios.get(`${url}/estoques-virtuais-ofertas`, {
          params: {
            filter: this.filter ? this.filter : null,
            ctcli: this.ctcli,
            segmentos: this.userAuth.segmentos,
          }
        });
        for (let i = 0; i < data.ofertas.length; i += 1) {
          for (let j = 0; j < this.dealers.length; j += 1) {
            if (this.dealers[j].account === data.ofertas[i].ctcli) {
              data.ofertas[i].dealer = this.dealers[j].name;
              break; 
            }
          }
        }
        this.itemsOfertasTabela = [];
        this.itemsOfertas = data.ofertas;
        // this.totalOfertas = data.total;
        for (let i = 0; i < this.itemsOfertas.length; i += 1) {
          if (this.itemsOfertas[i].status_oferta === 1) {
            this.itemsOfertasTabela.push(this.itemsOfertas[i]);
          }
        }
        this.totalOfertas = this.itemsOfertasTabela.length;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
      this.loading = false;
    },
    changePage() {
      this.loadData();
    },
    async changePublished() {
      this.published = !this.published;
      await this.loadData();
    },
    async changeInterested() {
      this.interested = !this.interested;
      await this.loadData();
    },
    async publishStock(item, status) {
      if(status) {
        if (!this.nome || !this.email || !this.telefone) {
          this.$swal(
            'Aviso!',
            'O preenchimento de todos os campos é obrigatório',
            'warning',
          );
          return;
        }
        await axios.post(`${url}/estoques-virtuais-ofertas`, {
          token: this.userAuth.token,
          id_estoque_virtual: item.id_estoque_virtual,
          id_usuario: this.userAuth.id,
          pedido_alemao: item.pedido_alemao,
          numero_sfat: item.numero_sfat,
          nome: this.nome,
          email: this.email,
          telefone: this.telefone,
          dealer: item.dealer,
        });
        await this.getOffers();
        await this.loadData();
      } else {
        this.$swal({
          title: 'Remover Veículo',
          text: 'Tem certeza de que deseja remover esse veículo da área de disponibilidade?',
          icon: 'warning',
          showCancelButton: true,
        }).then(async (willDelete) => {
          if (willDelete.isConfirmed) {
            try {
              await axios.patch(`${url}/estoques-virtuais-ofertas`, {
                token: this.userAuth.token,
                id_estoque_virtual: item.id_estoque_virtual,
              }).then(() => {
                this.$swal(
                  'Veículo Removido!',
                  'Veículo removido com sucesso!',
                  'success',
                  );
              });
            } catch (error) {
              this.$swal(
                'Falha!',
                'Não foi possível realizar a remoção',
                'error',
              );
            }
            await this.getOffers();
            await this.loadData();
          }
        });
      }
    },
    openModalAccept(item) {
      this.selectedAcceptDealer = null;
      this.acceptDealersOptions = [];
      for (let i = 0; i < this.user.dealers.length; i += 1) {
        this.acceptDealersOptions.push({
          value: this.user.dealers[i].account,
          text: this.user.dealers[i].name,
        });
      }
      this.acceptDealersOptions.sort(function(a,b) {
          return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
      });
      this.$bvModal.show(`accept${item.id_estoque_virtual}`);
    },
    async acceptStock (item) {
      if (!this.nome || !this.email || !this.telefone || !this.selectedAcceptDealer) {
        this.$swal(
          'Aviso!',
          'O preenchimento de todos os campos é obrigatório',
          'warning',
        );
        return;
      }
      try {
        await axios.post(`${url}/estoques-virtuais-aceites`, {
          token: this.userAuth.token,
          id_estoque_virtual: item.id_estoque_virtual,
          nome: this.nome,
          email: this.email,
          telefone: this.telefone,
          dealer: this.selectedAcceptDealer,
          id_user: this.userAuth.id,
        })
      } catch (error) {
        this.$swal(
          'Falha!',
          'Não foi possível realizar o repasse',
          'error',
        );
      }
      await this.getOffers();
      await this.loadData();
    },
    search() {
      if (this.showTab === 0) {
        this.items = [];
      } else {
        this.itemsOfertasTabela = [];
      }
      if (
        this.filter !== ''
        && this.filter !== null
        && this.filter.length > 2
      ) {
        if (this.showTab === 0) {
          clearTimeout(this.typingTimer);
          this.typingTimer = setTimeout(
            this.loadData,
            this.doneTypingInterval,
          );
        } else {
          clearTimeout(this.typingTimer);
          this.typingTimer = setTimeout(
            this.getOffers,
            this.doneTypingInterval,
          );
        }
      } else {
        if (this.showTab === 0) {
          this.items = [];
          this.loadData();
        } else {
          this.itemsOfertasTabela = [];
          this.getOffers();
        }
      }
    },
    resetSearch() {
      this.filter = null;
      if (this.showTab === 0) {
        this.loadData();
      } else {
        this.getOffers();
      }
    },
    convertDate(date) {
      if (date) {
        return (`${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`);
      }
      return '';
    },
    calculateDays(dtFat, dtEst) {
      const DAY = 24 * 60 * 60 * 1000;
      const dateFat = new Date(dtFat);
      const dateEst = new Date(dtEst);
      const mlsFat = dateFat.getTime();
      const mlsEst = dateEst.getTime();
      const dif = mlsEst - mlsFat;
      const qtdDays = dif / DAY;
      return (qtdDays);
    },
    async getAreasOperacionais() {
      try {
        const { data } = await axios.get(`${url}/dealersMB`, {
        headers: {
          'x-access-token': this.userAuth.token,
          'integration-key': '9e1a17ce5b329d3bf3cd0e618cfd83d57084f7944a9236ed2e2e86c2fba865b1',
        },
      });
        this.areasOperacionais = data;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async filterAop() {
      this.aopOptions = [];
      for (let i = 0; i < this.areasOperacionais.length; i += 1) {
        for (let j = 0; j < this.user.dealers.length; j += 1) {
          if (this.user.dealers[j].operational_area.toString() === this.areasOperacionais[i].carop) {
            let achou = false;
            for (let k = 0; k < this.aopOptions.length; k += 1) {
              if (this.aopOptions[k].value === this.areasOperacionais[i].carop) {
                achou = true;
              }
            }
            if (!achou) {
              this.aopOptions.push({
                value: this.areasOperacionais[i].carop,
                text: this.areasOperacionais[i].dcarop,
              });
            }
            break;
          }
        }
      }
      this.aopOptions.sort(function(a,b) {
          return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
      });
      this.aopOptions.unshift({ value: 'Todas', text: 'Todas' });
    },
    async filterDealer() {
      this.dealersOptions = [];
      for (let i = 0; i < this.user.dealers.length; i += 1) {
        if (
          this.selectedAop === 'Todas' ||
          this.user.dealers[i].operational_area.toString() === this.selectedAop
        )
        this.dealersOptions.push({
          value: this.user.dealers[i].account,
          text: this.user.dealers[i].name,
        });
      }
      this.dealersOptions.sort(function(a,b) {
          return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
      });
      this.dealersOptions.unshift({ value: 'Todas', text: 'Todas' });
    },

    async changeAopFilter() {
      await this.buildCtcli();
      this.filterDealer();
      if (this.showTab === 0) {
        this.loadData();
      } else {
        this.getOffers();
      }
    },
    async changeDealersFilter() {
      await this.buildCtcli();
      if (this.showTab === 0) {
        await this.loadData();
      } else {
        await this.getOffers();
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },
  async mounted() {
    await Promise.all([
      this.getUser({ id: this.userAuth.id, token: this.userAuth.token }),
      this.getDealers(),
      this.getAreasOperacionais(),
      this.getOffers(),
    ]);
    await this.filterAop();
    await this.filterDealer();

    this.nome = this.user.name;
    this.email = this.user.email;
    this.telefone = this.user.celphone;
    this.userType = this.user.type;
    for (const obj of this.user.dealers) {
      this.ctcli.push(obj.account);
    }
    await this.loadData();

  },
};
</script>

<style lang="scss" scoped>
.wrapp {
  padding: 16px;
  // max-height: calc(100vh - 72px);
  background-color: #f1f1f1;
  overflow: auto;
  font-size: x-small;
  height: calc(100vh - 90px);
}
.fa {
  font-size: 20px !important;
}
.fa-plus {
  color: green;
  cursor: pointer;
}
.fa-minus {
  color: red;
  cursor: pointer;
}
.fa-check {
  color: blue;
}
.fa-times {
  color: red;
}
.f-right {
  float: right;
}
.explain {
  background-color: transparent;
  border: none;
  color: #212529;
}
.btn-primary {
  background-color: #694cfe !important;
  border-color: #694cfe !important;
  margin-left: 10px;
  margin-top: 5px;
}
.dealer {
  display: none;
}
h5 {
  margin: 10px 0px 0px 0px !important;
}
</style>
<style>
.table td {
  padding: 0.5rem !important;
}
th {
    background-color: #70ad47;
    color: #fff;
}
.pt20 {
  padding-top: 20px;
}
.check-rounded::before {
  border-radius: 50%;
}
.wid100 {
  width: 100%;
}
.tbscroll {
  /* overflow: auto; */
}
.virtualstock {
  width: max-content;
}
.nopointer {
  cursor: default !important;
}
#sfatwrapp input {
  font-size: inherit;
  height: 30px !important;
}
#sfatwrapp button {
  font-size: inherit;
  height: 25px !important;
  padding: 5px;
  margin: 0;
}
#sfatwrapp select {
  font-size: inherit !important;
  height: 30px !important;
  padding: 5px !important;
  margin-top: 0px !important;
  min-width: 100%;
}
#sfatwrapp .custom-control-label {
  padding-top: 5px;
}
#sfatsearch {
  max-width: 100px;
}
</style>
